module.exports = __webpack_public_path__ + "media/irregular_lot.748f6d6d.svg";